import React, { useState } from 'react';
import PropTypes from 'prop-types';
import NormalSelect from 'react-select';
import CreatableSelect from 'react-select/creatable';
import {
  InputLabel, makeStyles, FormControl, useTheme, fade,
} from '@material-ui/core';
import { Controller } from 'react-hook-form';
import MenuList from './MenuList';

const useSelectStyles = makeStyles((theme) => ({
  label: {
    padding: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    transform: 'none',
  },
  labelFocus: {
    color: theme.palette.text.primary,
  },
  root: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(1),
  },
}));

const getCustomStyles = (theme) => ({
  control: (provided, { isFocused, isDisabled }) => ({
    ...provided,
    minHeight: '40px',
    borderRadius: '2px',
    backgroundColor: isDisabled ? theme.palette.grey[50] : '#fff',
    borderColor: isFocused ? theme.palette.primary.main : '#bdbdbd',
    boxShadow: isFocused ? `0 0 0 0.2rem ${fade(theme.palette.primary.main, 0.25)}` : 'none',
    boxSizing: 'border-box',
    color: isDisabled ? theme.palette.text.disabled : theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(14),
    transition: theme.transitions.create(['border-color', 'box-shadow']),
  }),
  menu: (provided) => ({
    ...provided,
    marginTop: 0,
    paddingTop: '4px',
    top: '88%',
    width: 'calc(100% - 16px)',
    borderRadius: '2px',
    borderColor: '#bdbdbd',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  }),
  option: (provided, { isDisabled, isFocused, isSelected }) => ({
    ...provided,
    backgroundColor: isSelected
      ? theme.palette.primary.main
      : isFocused
        ? fade(theme.palette.primary.main, 0.25)
        : 'transparent',
    ':active': {
      backgroundColor:
                !isDisabled
                && (isSelected
                  ? fade(theme.palette.primary.main, 0.5)
                  : fade(theme.palette.primary.main, 0.25)),
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
});

function USelect({
  label, fullWidth, options, disabled, creatable, name, control,
}) {
  const classes = useSelectStyles();
  const theme = useTheme();
  const customStyles = getCustomStyles(theme);
  const [inputFocus, setInputFocus] = useState(false);

  const handleFocus = () => setInputFocus(true);
  const handleBlur = () => setInputFocus(false);
  const Select = creatable ? CreatableSelect : NormalSelect;

  return (
    <FormControl fullWidth={fullWidth} focused={inputFocus}>
      <InputLabel className={classes.label}>
        {label}
      </InputLabel>
      <Controller
        as={Select}
        name={name}
        control={control}
        className={classes.root}
        components={{ MenuList }}
        options={options}
        styles={customStyles}
        isDisabled={disabled}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder="Selecione"
        label={label}
      />
    </FormControl>
  );
}

USelect.defaultProps = {
  fullWidth: false,
  disabled: false,
  creatable: false,
};

USelect.propTypes = {
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  creatable: PropTypes.bool,
  label: PropTypes.string.isRequired,
  options: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
};

export default USelect;
